import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.79653 12L3.30752 14.2337C2.56416 14.6035 2.56416 15.6712 3.30752 16.0411L11.5567 20.1457C11.8361 20.2848 12.1639 20.2848 12.4433 20.1457L20.6925 16.0411C21.4358 15.6712 21.4358 14.6035 20.6925 14.2337L16.2035 12M16.2035 12L12.4433 13.871C12.1639 14.01 11.8361 14.01 11.5567 13.871L7.79653 12L3.30752 9.76635C2.56416 9.39647 2.56416 8.32881 3.30752 7.95892L11.5567 3.85428C11.8361 3.71524 12.1639 3.71524 12.4433 3.85427L20.6925 7.95892C21.4358 8.32881 21.4358 9.39647 20.6925 9.76635L16.2035 12Z",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }